import { render } from "./ArticlesItemImage.vue?vue&type=template&id=c45060a2"
import script from "./ArticlesItemImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesItemImage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesItemImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c45060a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c45060a2', __exports__)) {
    api.reload('c45060a2', __exports__)
  }
  
  module.hot.accept("./ArticlesItemImage.vue?vue&type=template&id=c45060a2", () => {
    api.rerender('c45060a2', render)
  })

}


export default __exports__